import React from 'react';
import {
  Modal,
} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';


const ModalCommentTableList = ({showModal, setShowModal, showComments, showVisitor, showDate, showHour}) => {
  const {t} = useTranslation();
  return (
    <>
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="fas fa-comment"></i>
          </div>
        </Modal.Header>
        <div className="modal-body">
          <p className="text-center">{t(translations.APPOINTMENT_COMMENT)}  {showVisitor}  {t(translations.APPOINTMENT_COMMENT2)}  {showDate.toLocaleDateString('en-GB')}  {t(translations.APPOINTMENT_COMMENT3)}  {showHour}.</p>
        </div>
        <Modal.Body style={{}}>
          <p style={{flex: 1, flexWrap: 'wrap'}}>{showComments}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCommentTableList;
